import Vue from 'vue'
import Vuex from 'vuex'
import { setItem,getItem } from '../utils/utils.js'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
    token: getItem('webtoken'),
    userInfo: getItem('userInfo'),
    loginState: getItem('loginState'),
    personType: getItem('personType'),
    loginPhone: getItem('loginPhone'),
    showLoginTip: false,
    showChangePassword: false,
    showQx: false
  },
  mutations: {
    setChangePassword(state,data){
      state.showChangePassword = data
    },
    setQx(state, data){
      state.showQx = data
    },
    setLoginTip(state, data){
      state.showLoginTip = data
    },
    setLoginContent(state, data){
      state.token = data
      setItem('webtoken',data)
    },
    setLoginPhone(state, data){
      state.loginPhone = data
      setItem('loginPhone',data)
    },
    setUserInfo(state, data){
      state.userInfo = data
      setItem('userInfo',data)
    },
    setLoginState(state, data){
      state.loginState = data
      setItem('loginState',data)
    },
    setPersonType(state, data) {
      state.personType = data
      setItem('personType',data)
    },
    exitLogin(state){
      state.loginState = false
      state.personType = null
      state.token = null
      state.userInfo = null
      window.localStorage.clear()
    }
  },
  actions: {
  },
  modules: {
  }
})

export default store

